 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","pages-authentication-authentication-module":"pages-authentication-authentication-module","pages-authentication-components-auth-email-auth-email-module":"pages-authentication-components-auth-email-auth-email-module","pages-authentication-components-auth-password-auth-password-module":"pages-authentication-components-auth-password-auth-password-module","pages-authentication-components-auth-register-auth-register-module":"pages-authentication-components-auth-register-auth-register-module","pages-authentication-components-auth-register-password-auth-register-password-module":"pages-authentication-components-auth-register-password-auth-register-password-module","pages-authentication-components-recovery-password-recovery-password-module":"pages-authentication-components-recovery-password-recovery-password-module","pages-result-result-module":"pages-result-result-module","pages-verify-account-verify-account-module":"pages-verify-account-verify-account-module","repaso-components-lecciones-incluidas-lecciones-incluidas-module":"repaso-components-lecciones-incluidas-lecciones-incluidas-module","repaso-repaso-module":"repaso-repaso-module","subscription-subscription-module":"subscription-subscription-module","default~main-menu-main-menu-module~pages-lesson-menu-lesson-menu-module~pages-tabs-tabs-module":"default~main-menu-main-menu-module~pages-lesson-menu-lesson-menu-module~pages-tabs-tabs-module","pages-tabs-tabs-module":"pages-tabs-tabs-module","default~main-menu-main-menu-module~popups-enable-tutorial-enable-tutorial-module":"default~main-menu-main-menu-module~popups-enable-tutorial-enable-tutorial-module","main-menu-main-menu-module":"main-menu-main-menu-module","default~pages-exercise-components-act-exit-popup-act-exit-popup-module~pages-exercise-exercise-module":"default~pages-exercise-components-act-exit-popup-act-exit-popup-module~pages-exercise-exercise-module","default~pages-exercise-components-settings-settings-module~pages-exercise-exercise-module":"default~pages-exercise-components-settings-settings-module~pages-exercise-exercise-module","pages-exercise-exercise-module":"pages-exercise-exercise-module","default~pages-user-account-components-popup-choose-image-popup-choose-image-module~pages-user-accoun~d234ed68":"default~pages-user-account-components-popup-choose-image-popup-choose-image-module~pages-user-accoun~d234ed68","user-account-components-change-pass-change-pass-module":"user-account-components-change-pass-change-pass-module","user-account-components-privacy-policy-privacy-policy-module":"user-account-components-privacy-policy-privacy-policy-module","user-account-components-profile-profile-module":"user-account-components-profile-profile-module","default~pages-user-account-components-popup-logout-popup-logout-module~user-account-user-account-module":"default~pages-user-account-components-popup-logout-popup-logout-module~user-account-user-account-module","user-account-user-account-module":"user-account-user-account-module","pages-video-video-module":"pages-video-video-module","user-account-components-certificates-certificates-module":"user-account-components-certificates-certificates-module","pages-launch-launch-module":"pages-launch-launch-module","pages-subscription-components-redeem-redeem-module":"pages-subscription-components-redeem-redeem-module","pages-user-account-components-tutorial-slides-tutorial-slides-module":"pages-user-account-components-tutorial-slides-tutorial-slides-module","polyfills-core-js":"polyfills-core-js","polyfills-css-shim":"polyfills-css-shim","polyfills-dom":"polyfills-dom","shadow-css-58508bb5-js":"shadow-css-58508bb5-js","subscription-components-payment-success-payment-success-module":"subscription-components-payment-success-payment-success-module","subscription-components-terms-terms-module":"subscription-components-terms-terms-module","subscription-components-web-payment-web-payment-module":"subscription-components-web-payment-web-payment-module","user-account-components-faq-faq-module":"user-account-components-faq-faq-module","user-account-components-languages-languages-module":"user-account-components-languages-languages-module","swiper-bundle-95afeea2-js":"swiper-bundle-95afeea2-js","focus-visible-f4ad4f1a-js":"focus-visible-f4ad4f1a-js","input-shims-bc550f99-js":"input-shims-bc550f99-js","keyboard-5742b5da-js":"keyboard-5742b5da-js","status-tap-b46a1b02-js":"status-tap-b46a1b02-js","swipe-back-2154c9a7-js":"swipe-back-2154c9a7-js","tap-click-71d2324a-js":"tap-click-71d2324a-js","user-account-components-app-reminders-app-reminders-module":"user-account-components-app-reminders-app-reminders-module"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
